import React, { useState, useEffect } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";
import { Oval } from "react-loader-spinner";

import CertificateofAuthenticity from "./CertificateofAuthenticity";
import Currency from "Component/Currency/Currency";

import {
  uploadFile,
  getCategories,
  postItem,
  getArtByUserIdRequest,
  getSubCategories,
  addPhysicalSellItem,
  addPhysicalTransaction,
} from "store/actions";

export default function Createnftphysical() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { itemId, resellId } = useParams();
  const [menu, menuopen] = useOutletContext();
  const [listedArtworkIds, setListedArtworkIds] = useState([]);

  // Redux selectors
  const { user } = useSelector((state) => state?.Login);
  const { loading } = useSelector((state) => state?.items);
  const fileLoading = useSelector((state) => state?.File?.loading);
  const { subCategory, categories } = useSelector((state) => state?.categories);

  // State management
  const [rows, setRows] = useState([{ sizeone: "", sizeTwo: "" }]);
  const [symbol, setSymbol] = useState("");
  const [convertIntoCurrency, setConvertIntoCurrency] = useState("USD");
  const [search, setSearch] = useState("");
  const [approveArt, setApproveArt] = useState([]);
  const [approvedsearchart, setApprovedsearchart] = useState([]);
  const [showart, setShowart] = useState(null);
  const [previewart, setPreviewart] = useState(null);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [descLen, setDescLen] = useState(2500);
  const [isSupportDoc, setSupportDoc] = useState(false);

  // Modal states
  const [upArt, setAploadArt] = useState(false);
  const [nftCreate, setnftCreate] = useState(false);
  const [showAuthenticity, setshowAuthenticity] = useState(false);

  // Form fields
  const [fields, setFields] = useState({
    image_id: "",
    image_url: "",
    support_docs: "",
    relatedImages: "",
    token_hash: "",
    description: "",
    name: "",
    subtitle: "",
    category_id: "",
    subcategory: "",
    price: 0,
    royalties: "0",
    publicUrl: "",
    hash: "",
    limitededitionquantity: "",
    docsName: "",
    supportDocDescription: "",
    premium_print_cost: 0,
    printable_doc: "",
    printable_image_id: "",
    physical_print_option: "",
    physical_print_unique_id_placement: "",
    edition: "Limited Edition",
    docs_upload: "",
  });

// add by ankit for ristrict multiple size option for limited edition 
    useEffect(() => {
      if (fields.edition === "Limited Edition") {
        setRows([{ sizeone: "", sizeTwo: "" }]);
      }

      if (fields.edition === "Open Edition" && rows.length === 0) {
        setRows([{ sizeone: "", sizeTwo: "" }]);
      }
    }, [fields.edition]);

  // Effects
  useEffect(() => {
    menu(false);
  }, [menu]);

  useEffect(() => {
    if (user?._id) {
      dispatch(
        getArtByUserIdRequest(user._id, (res) => {
         
            console.log("upcoming data",res.data);
          // Log each artwork to see their properties
          res.data?.forEach((item, index) => {
            console.log(`🎨 Artwork ${index + 1}:`, {
              id: item._id,
              title: item?.artInfo?.title,
              adminStatus: item.adminStatus,
              physical_print: item.physical_print,
              status: item.status,
              token_id: item.token_id,
              image: item.image,
              is_listed: item.is_listed,
              sell_item_id: item.sell_item_id,
              // Log all properties to see what's available
              allProperties: Object.keys(item),
            });
          });

          const physicalArts = res.data.filter((item) => {
            const isApproved = item.adminStatus === "Approved";
            const printerApproved = item?.artInfo?.printer_status === "Approved";
            const statusCheck = item.status === true; // Unlisted items
            // const noTokenId = !item.token_id || item.token_id === "0";
            // const notListed = !item.sell_item_id; // Exclude already listed items
            const hasPrinter = item?.artInfo?.printer_id ? true : false; // NEW CHECK

          // console.log(`🔍 Filtering ${item?.artInfo?.title || "Untitled"}:`, {
          //   isApproved,
          //   isPhysical,
          //   statusCheck,
          //   noTokenId,
          //   notListed,
          //   hasPrinter,
          //   sell_item_id: item.sell_item_id,
          //   passesFilter:
          //     isApproved &&
          //     isPhysical &&
          //     statusCheck &&
          //     noTokenId &&
          //     notListed &&
          //     hasPrinter,
          // });

          return (
            isApproved &&
            printerApproved &&
            statusCheck &&
            hasPrinter
          );
        });
          setApproveArt(physicalArts);
          setApprovedsearchart(physicalArts);
        })
      );
    }
  }, [user?._id, dispatch]);

  useEffect(() => {
    dispatch(getSubCategories());
    dispatch(getCategories({ limit: 100, orderBy: "", order: "", page: 1 }));
  }, [dispatch]);

  useEffect(() => {
    setDescLen(2500 - (fields?.description?.length || 0));
  }, [fields?.description]);

  useEffect(() => {
    setSupportDoc(!!fields?.relatedImages);
  }, [fields?.relatedImages]);

  useEffect(() => {
    if (search !== "") {
      setApprovedsearchart(
        approveArt.filter((item) => {
          const title =
            item?.artInfo?.title ||
            item?.images?.file_name?.split(".")[0] ||
            "";
          return title.toLowerCase().includes(search.toLowerCase());
        })
      );
    } else {
      setApprovedsearchart(approveArt); // This maintains the physical filter
    }
  }, [search, approveArt]);

  // Handlers
  const handleInputChange = (e, index) => {
    const values = [...rows];
    values[index][e.target.name] = e.target.value;
    setRows(values);
  };

  const handleAddRow = () => {

    if (rows.length >= 4) {
      return toastr.warning("Only four entries are allowed");
    }
    setRows([...rows, { sizeone: "", sizeTwo: "" }]);
  };

  const handleRemoveRow = (index) => {
    const values = [...rows];
    values.splice(index, 1);
    setRows(values);
  };

  const handleEditionChange = (value) => {
    setFields((p) => ({ ...p, edition: value }));
  };

  const onChangeHandler = (name) => (evt) => {
    evt.preventDefault();
    let { value } = evt.target;

    if (name === "premium_print_cost" || name === "price") {
      value = value.replace(/[^0-9.]/g, "");
      if ((value.match(/\./g) || []).length > 1) {
        value = value.slice(0, value.lastIndexOf("."));
      }
    }

    setFields((prev) => ({ ...prev, [name]: value }));
  };

  const categoryHandler = (e) => {
    const category = e.target.value;
    const data = subCategory?.filter(
      (item) => item?.category?._id === category
    );
    setSubCategoryList(data);
    setFields((prevState) => ({ ...prevState, category_id: category }));
  };

  const handlePhysicalPrintChange = (name, value, e) => {
    e.preventDefault();
    setFields((p) => ({ ...p, [name]: value }));
  };

  const setCurrnencyTobeConverted = (currency, symbol) => {
      if (!currency || !symbol) {
        toastr.error("Please select a currency first");
        return;
      }
    setConvertIntoCurrency(currency);
    setSymbol(symbol);
  };

  const selectApproveArt = () => setAploadArt(true);
  const closedialogBox = () => {
    setAploadArt(false);
    setSearch("");
  };
  const showselectart = (item) => setShowart(item);
  const Authenticity = () => setshowAuthenticity(!showAuthenticity);

  const uploadImgae = () => {
    if (!showart) return toastr.error("Please select an artwork first.");

    setPreviewart(showart);
    setAploadArt(false);
    setFields((prev) => ({
      ...prev,
      image_id: showart?.image, // correct image ID
      image_url: showart?.publicUrl, // correct URL
      hash: showart?.hash || "",
      publicUrl: showart?.publicUrl || "",
      name: showart?.artInfo?.title || "",
      subtitle: showart?.artInfo?.subtitle || "",
      printable_image_id : showart?.artInfo?.printer_image,
    }));
  };
  
  const handleDocsChange = (name) => (evt) => {
    if (!evt) return;

    const docs = evt.target.files;
    if (docs.length === 0) return;

    const ext = docs[0].name.split(".").pop().toLowerCase();

    if (name === "printableImage" && !["tiff", "jpeg","jpg","JPG","JPEG","TIFF","TIF", "tif"].includes(ext)) {
      return toastr.error("Only JPG, JPEG, TIFF and TIF extensions are allowed");
    }

    if (
      name === "supportdoc" &&
      !["png", "jpg", "jpeg", "pdf", "mp3", "mp4"].includes(ext)
    ) {
      return toastr.error("Only png, jpg, pdf extensions allowed");
    }

    const file = docs[0];

    if (name === "printableImage") {
      const filename = file.name.replace(/\s/g, "");
      const removed_tiff = filename.split(".")[0];

      setFields((prevState) => ({
        ...prevState,
        printable_doc: removed_tiff,
      }));

      const uploadPrintableImageSuccess = (response) => {
        const { _id } = response.data;
        setFields((prev) => ({ ...prev, printable_image_id: _id }));
        toastr.success("Printable document has been uploaded successfully.");
      };

      dispatch(uploadFile({ image: file }, uploadPrintableImageSuccess));
    } else {
      const uploadDocsSuccess = (response) => {
        const { _id, file_name } = response.data;
        setFields((prev) => ({
          ...prev,
          relatedImages: _id,
          docsName: file_name,
        }));
        toastr.success(
          "Additional support document has been uploaded successfully."
        );
      };

      dispatch(uploadFile({ image: file }, uploadDocsSuccess));
      setFields((prevState) => ({
        ...prevState,
        docs_upload: file.name,
      }));
    }
  };

  const reUpload = () => {
    setFields((prevState) => ({
      ...prevState,
      docs_upload: "",
      relatedImages: "",
    }));
    setSupportDoc(false);
  };

  const reUploadPrintable = () => {
    setFields((prevState) => ({
      ...prevState,
      printable_doc: "",
      printable_image_id: "",
    }));
  };

  const reArtUpload = () => {
    setPreviewart(null);
    setShowart(null);
    setFields((prev) => ({
      ...prev,
      image_id: "",
      image_url: "",
      name: "",
      subtitle: "",
    }));
  };
  const inchToCm = (inch) => {
    if (!inch) return 0;
    return Number((inch * 2.54).toFixed(2));
  };

  const ondatasubmit = async (evt) => {
    evt.preventDefault();

    // Validations
    if (!fields?.image_id) {
      return toastr.error("Image is required");
    }
    if (!symbol.trim()) {
      return toastr.error("Select Currency is required");
    }
    if (!fields?.description) {
      return toastr.error("Item description is required");
    }

    if (fields?.description.length > 2500) {
      return toastr.error(
        "Item description should not be greater than 2500 characters"
      );
    }
    if(fields.limitededitionquantity < 0){
      return toastr.error(
        "Item Edition Quantity should be greater than 0"
      );
    }
    if (!fields?.name) {
      return toastr.error("Listing title is required");
    }

    if (!fields?.subtitle) {
      return toastr.error("Listing subtitle is required");
    }

    if (!fields?.category_id) {
      return toastr.error("Category is required");
    }

    if (!fields?.subcategory) {
      return toastr.error("Subcategory is required");
    }
    // if(!fields?.premium_print_cost){
    //   fields?.premium_print_cost = 0
    // }

    if (
      parseFloat(fields?.premium_print_cost) < 0
    ) {
      return toastr.error(
        "Premium print cost cannot be negative"
      );
    }

    if (!fields?.physical_print_option) {
      return toastr.error("Print option is required.");
    }

    if (!fields?.physical_print_unique_id_placement) {
      return toastr.error("Print number placement is required.");
    }

    const hasEmptyField = rows.some(
      (row) => !row.sizeone?.trim() || !row.sizeTwo?.trim()
    );
    if (hasEmptyField) {
      return toastr.error(
        "Size width and height are required for all entries."
      );
    }

    const sizePairs = rows.map(
      (row) => `${row.sizeone.trim()}x${row.sizeTwo.trim()}`
    );
    const uniqueSizePairs = new Set(sizePairs);
    if (sizePairs.length !== uniqueSizePairs.size) {
      return toastr.error("Each size (width x height) must be unique.");
    }

    if (fields?.edition === "Limited Edition") {
      if (
        !fields?.limitededitionquantity ||
        parseInt(fields?.limitededitionquantity) <= 0
      ) {
        return toastr.error(
          "Limited edition quantity is required and must be greater than 0"
        );
      }
    }

    try {
      setnftCreate(true);

      const itemData = {
        name: fields.name,
        description: fields.description,
        media: fields.image_id,
        image_id: fields.image_id,
        image_url: fields.image_url,
        hash: fields.hash,
        publicUrl: fields.publicUrl,
        user_id: user._id,
        author_id: user._id,
        current_owner: user._id,
        category_id: fields.category_id,
        subcategory: fields.subcategory,
        blockchain: "polygon",
        token_id: "",
        token_hash: "",
        relatedImages: fields.relatedImages ? [fields.relatedImages] : [],
        supportDocDescription: fields.supportDocDescription || "",
        saleType: "fixed",
      };

      dispatch(
        postItem(itemData, async (response) => {
          if (response?.status === "failure") {
            setnftCreate(false);
            return toastr.error("Artwork name already exists");
          }

          const art_id = response.data._id;

        const formatSizes = (rows) =>
          rows.map((row) => ({
            height:
              user.artSizeUnit === "Inches"
                ? inchToCm(row.sizeone)
                : Number(row.sizeone),

            width:
              user.artSizeUnit === "Inches"
                ? inchToCm(row.sizeTwo)
                : Number(row.sizeTwo),
          }));
          const editionQuantity =
            fields.edition === "Limited Edition"
              ? parseInt(fields.limitededitionquantity)
              : 999999;

          const priceValue = parseFloat(fields.premium_print_cost);
          if (isNaN(priceValue) || priceValue < 0) {
            setnftCreate(false);
            return toastr.error("Invalid premium print cost value");
          }

          const physicalSellItemData = {
            owner_id: user._id,
            price: priceValue,
            category_id: fields.category_id,
            subcategory_id: fields.subcategory,
            listing_image_id: fields.image_id,
            printable_image_id: fields.printable_image_id,
            sizes: formatSizes(rows),
            edition: fields.edition,
            no_of_copies: editionQuantity,
            premium_print_cost: priceValue,
            physical_print_option: fields.physical_print_option,
            physical_print_unique_id_placement:
              fields.physical_print_unique_id_placement,
          };
    // no need transaction for physical listing
        dispatch(
            addPhysicalSellItem(
              physicalSellItemData,
              async (sellItemResponse) => {
                if (sellItemResponse?.status === "failure") {
                  setnftCreate(false);
                  return toastr.error("Failed to create list Artwork");
                } 
                     
                
                        setnftCreate(false);
               toastr.success("Physical artwork listed successfully!");
                    return navigate("/profile/nft/created");
                
                     }
            )
                );  

                // const physicalTransactionData = {
                //   sell_item_id: sell_item_id,
                //   art_id: art_id,
                //   buyer_id: user._id, // same user for listing
                //   seller_id: user._id, // same user for listing
                //   price: priceValue,
                //   quantity: 1,
                //   payment_method: "none",
                //   payment_status: "pending",
                // };

                // dispatch(
                //   addPhysicalTransaction(physicalTransactionData, (txRes) => {
                //     if (txRes?.status === "failure") {
                //       setnftCreate(false);
                //       return toastr.error(
                //         "Failed to create physical transaction"
                //       );
                //     }

                //     toastr.success("Physical artwork listed successfully!");
                //     setnftCreate(false);
                //     return navigate("/profile/nft/created");
                //   })
                // );
             
        
        })
      );
    } catch (err) {
      setnftCreate(false);
      console.error("Submission error:", err);
      return toastr.error("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      {(loading || fileLoading) && (
        <div className="loaderBoxMiane">
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      )}
      <Modal
        id="approved-artwork"
        className="EmailVerifyBoxModel uploadimg selectArt text-center"
        show={upArt}
        centered
        animation={false}
      >
        <div className="dialogHeader px-4 pt-4">
          <div className="text-start">
            <h3 className="mb-1">Approved Physical Artwork</h3>
            <p>
              Select any one approved physical artwork to create physical print
            </p>
          </div>
          <button onClick={closedialogBox} className="margin-button">
            <i className="fa-regular fa-xmark"></i>
          </button>
        </div>

        <div className="px-4 py-3">
          {approveArt.length > 0 && (
            <Row className="searchBoxdialog" id="searchBoxdialog">
              <div className="col-md-3">
                <div className="position-relative">
                  <Input
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    type="text"
                    className="searchInput form-control w-100"
                  />
                  {search && (
                    <button
                      onClick={() => setSearch("")}
                      className="searchcanslbtn"
                    >
                      <i className="fa-regular fa-xmark" />
                    </button>
                  )}
                </div>
              </div>
            </Row>
          )}
        </div>

        <div className="overflowUploadbOx px-4">
          <div className="upoadedImage">
            <div className="uploadedArt selectart">
              <div className="row">
                {approvedsearchart.length > 0 ? (
                  approvedsearchart.map((item, index) => (
                    <Col
                      key={index}
                      className="mb-3"
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                    >
                      <div
                        className="image"
                        onClick={() => showselectart(item)}
                      >
                        <Label
                          style={{
                            border: "1px solid var(--gray3)",
                            borderRadius: "0.5rem",
                            height: "150px !important",
                          }}
                          className={showart?._id === item?._id ? "active" : ""}
                          htmlFor="image1"
                        >
                          <figure>
                            <img
                              src={item?.publicUrl}
                              alt="Art"
                              className="img-class"
                              style={{
                                objectFit: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                            />

                            <figcaption className="p-1">
                              {item?.artInfo
                                ? item.artInfo.title.length > 21
                                  ? item.artInfo.title.substring(0, 21) + "..."
                                  : item.artInfo.title
                                : item?.artInfo?.title || "Untitled".length > 21
                                ? item.images.file_name
                                    .split(".")[0]
                                    .substring(0, 21) + "..."
                                : item.images.file_name.split(".")[0]}
                            </figcaption>
                          </figure>
                        </Label>
                      </div>
                    </Col>
                  ))
                ) : (
                  <div className="text-center py-4">
                    <h3>No Physical Arts Available</h3>
                    <p>
                      All your approved physical artworks have been listed or no
                      physical artworks are available.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {approvedsearchart.length > 0 && (
          <div className="text-center px-3 pb-3">
            <button
              className="btn btn-primary px-5"
              id="submit-btns"
              onClick={uploadImgae}
            >
              Submit
            </button>
          </div>
        )}
      </Modal>

      <Modal
        className="EmailVerifyBoxModel uploadimg selectArt text-center"
        show={nftCreate}
        centered
        animation={false}
      >
        <div className="nftLoading">
          <div className="loaderNFT">
            <i className="fa-thin fa-loader"></i>
          </div>
          <h3>
            Your physical artwork is being prepared for the marketplace...
          </h3>
        </div>
      </Modal>

      <Modal
        className="AuthenticityBoxModel uploadimg selectArt text-center"
        show={showAuthenticity}
        centered
        animation={false}
      >
        <CertificateofAuthenticity
          dialogOpan={Authenticity}
          previewart={
            previewart?.artInfo?.title || previewart?.images?.file_name
          }
          setArtWorkId={fields?.image_id}
        />
      </Modal>

      <Row>
        <Col lg={12} className="mb-1">
          <h1>
            <i onClick={menuopen} className="fa-light fa-bars-sort"></i>
          </h1>
        </Col>
        <Col lg={12}>
          {!resellId && !itemId && (
            <Form>
              <Row>
                <Col lg={12}>
                  <div className="createCollection uploadFilecrete mb-1">
                    <div className="upload-btn-wrapper">
                      <div className="text-center uploadimgnew">
                        {previewart?.publicUrl ? (
                          <div className="position-relative">
                            <img
                              src={previewart.publicUrl}
                              className="img-fluid"
                              alt=""
                            />
                            <button
                              type="button"
                              onClick={reArtUpload}
                              className="upoadDocClose closebtnart"
                            >
                              <i className="fa-solid fa-circle-xmark"></i>
                            </button>
                          </div>
                        ) : (
                          <Label
                            onClick={selectApproveArt}
                            className="d-grid cursor-pointer"
                          >
                            Select Approved Physical Art
                          </Label>
                        )}
                      </div>
                    </div>
                    <p className="mb-3 text-center uploadimgText">
                      Select your approved physical artwork for exclusive print
                      creation
                    </p>
                  </div>

                  <div className="createCollection">
                    {/* <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Printable Format</Label>
                      {fields?.printable_doc ? (
                        <div className="uploaddocs position-relative">
                          <Label
                            className="position-relative"
                            htmlFor="printableDocs"
                          >
                            <button
                              type="button"
                              onClick={reUploadPrintable}
                              className="upoadDocClose"
                            >
                              <i className="fa-solid fa-circle-xmark"></i>
                            </button>
                            <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                            &nbsp;{fields.printable_doc}
                          </Label>
                        </div>
                      ) : (
                        <div className="uploaddocs">
                          <Input
                            className="d-none"
                            type="file"
                            name="printableImage"
                            id="printableDocs"
                            onChange={handleDocsChange("printableImage")}
                          />
                          <Label htmlFor="printableDocs">
                            <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                            &nbsp; UPLOAD FROM YOUR DEVICE
                          </Label>
                          <p className="pdecription mb-1 d-flex gap-2 align-items-center">
                            <i className="fa-regular fa-circle-exclamation"></i>
                            <span>
                              Upload the high quality file approved by your
                              print shop (JPG, JPEG, TIFF, and TIF format)
                            </span>
                          </p>
                        </div>
                      )}
                    </FormGroup> */}

                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Support Document</Label>
                      {fields?.docs_upload ? (
                        <div className="uploaddocs position-relative">
                          <Label
                            className="position-relative"
                            htmlFor="supportDocs"
                          >
                            <button
                              type="button"
                              onClick={reUpload}
                              className="upoadDocClose"
                            >
                              <i className="fa-solid fa-circle-xmark"></i>
                            </button>
                            <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                            &nbsp;{fields.docs_upload}
                          </Label>
                        </div>
                      ) : (
                        <div className="uploaddocs">
                          <Input
                            className="d-none"
                            type="file"
                            name="supportdoc"
                            id="supportDocs"
                            onChange={handleDocsChange("supportdoc")}
                          />
                          <Label htmlFor="supportDocs">
                            <i className="fa-sharp fa-light fa-file-arrow-up"></i>
                            &nbsp; UPLOAD FROM YOUR DEVICE
                          </Label>
                        </div>
                      )}
                    </FormGroup>

                    {isSupportDoc && (
                      <FormGroup className="form-group mb-4">
                        <Label className="mb-1">
                          Support Document Description
                        </Label>
                        <div className="position-relative">
                          <Input
                            type="textarea"
                            name="supportDocDescription"
                            placeholder="Enter text here"
                            value={fields?.supportDocDescription}
                            maxLength={1000}
                            onChange={onChangeHandler("supportDocDescription")}
                            className="form-control bg-white"
                          />
                          <div className="addresmsg position-absolute bottom-0 end-0">
                            {1000 -
                              (fields?.supportDocDescription?.length || 0)}
                            /1000
                          </div>
                        </div>
                      </FormGroup>
                    )}

                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Item Description</Label>
                      <div className="position-relative">
                        <Input
                          type="textarea"
                          name="description"
                          maxLength={2500}
                          placeholder="Enter text here"
                          value={fields?.description}
                          onChange={onChangeHandler("description")}
                          className="form-control bg-white"
                        />
                        <div className="addresmsg position-absolute bottom-0 end-0">
                          {descLen}/2500
                        </div>
                      </div>
                    </FormGroup>

                    <FormGroup className="form-group mb-4">
                      <Label className="mb-2 listingtext">
                        Listing Details
                      </Label>
                      <FormGroup className="form-group mb-4">
                        <Label className="mb-1 lableSmall">Listing Title</Label>
                        <Input
                          name="name"
                          value={fields?.name}
                          onChange={onChangeHandler("name")}
                          placeholder="Enter text here"
                          className="form-control bg-white"
                        />
                      </FormGroup>
                      <FormGroup className="form-group mb-4">
                        <Label className="mb-1 lableSmall">
                          Listing Subtitle
                        </Label>
                        <Input
                          name="subtitle"
                          placeholder="Enter text here"
                          value={fields?.subtitle}
                          onChange={onChangeHandler("subtitle")}
                          className="form-control bg-white"
                        />
                      </FormGroup>
                    </FormGroup>

                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Select Category</Label>
                      <Input
                        type="select"
                        value={fields?.category_id}
                        className="form-control bg-white"
                        onChange={categoryHandler}
                      >
                        <option value="">Select Category</option>
                        {categories?.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <FormGroup className="form-group mb-4">
                      <Label className="mb-1">Select Subcategory</Label>
                      <Input
                        type="select"
                        className="form-control bg-white"
                        name="subcategory"
                        value={fields?.subcategory}
                        onChange={onChangeHandler("subcategory")}
                      >
                        <option value="">Select Subcategory</option>
                        {subCategoryList?.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>

                    <Row>
                      <div className="mb-3">
                        <div className="CustomeCheckBox customeRadioNew">
                          <Input
                            id="LimitedEdition"
                            checked={fields.edition === "Limited Edition"}
                            onChange={() =>
                              handleEditionChange("Limited Edition")
                            }
                            type="checkbox"
                          />
                          <label htmlFor="LimitedEdition"></label>
                          <div>
                            <span className="text-black certificate-text">
                              Limited Edition
                            </span>
                          </div>
                          <Input
                            id="OpenEdition"
                            checked={fields?.edition === "Open Edition"}
                            onChange={() => handleEditionChange("Open Edition")}
                            type="checkbox"
                          />
                          <label htmlFor="OpenEdition"></label>
                          <div>
                            <span className="text-black certificate-text">
                              Open Edition
                            </span>
                          </div>
                        </div>
                      </div>

                      <Col lg={12} className="mb-3">
                        <div className="bypricenow">
                          <Row>
                            <FormGroup className="form-group">
                              <div className="canvas-price">
                                <div>
                                  <Label>Premium Print Cost</Label>
                                  <div className="printcost">
                                    <div className="position-relative">
                                      <div className="currSym">{symbol}</div>
                                      <Input
                                        type="text"
                                        name="premium_print_cost"
                                        value={fields?.premium_print_cost}
                                        className="ps-5"
                                        onChange={onChangeHandler(
                                          "premium_print_cost"
                                        )}
                                      />
                                    </div>
                                    <Currency
                                      setCurrnencyTobeConverted={
                                        setCurrnencyTobeConverted
                                      }
                                    />
                                  </div>
                                </div>

                                <div>
                                  <Label>Print Option</Label>
                                  <div className="printStyle p-0 mt-0">
                                    <div className="d-flex gap-3">
                                      <button
                                        className={`printcommon-btn ${
                                          fields?.physical_print_option ===
                                          "Canvas"
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={(e) =>
                                          handlePhysicalPrintChange(
                                            "physical_print_option",
                                            "Canvas",
                                            e
                                          )
                                        }
                                      >
                                        Canvas
                                      </button>
                                      <button
                                        className={`printcommon-btn ${
                                          fields?.physical_print_option ===
                                          "Paper"
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={(e) =>
                                          handlePhysicalPrintChange(
                                            "physical_print_option",
                                            "Paper",
                                            e
                                          )
                                        }
                                      >
                                        Paper
                                      </button>
                                      <button
                                        className={`printcommon-btn ${
                                          fields?.physical_print_option ===
                                          "Both"
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={(e) =>
                                          handlePhysicalPrintChange(
                                            "physical_print_option",
                                            "Both",
                                            e
                                          )
                                        }
                                      >
                                        Both
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <form>
                                <div className="row mt-3">
                                  <Col className="mb-4" xl={6}>
                                    <div>
                                      <Label className="mb-2">Size</Label>
                                      {fields.edition === "Open Edition" && (
                                        <button
                                          className="add-dlt-btn"
                                          onClick={handleAddRow}
                                        >
                                          <img
                                            src="/images/svg/addicon.svg"
                                            className="img-width"
                                            alt=""
                                          />
                                        </button>
                                      )} <Label className="mb-2"><b>{`(${user.artSizeUnit})`}</b></Label>
                                    </div>
                                    {rows.map((row, index) => (
                                      <div key={index}>
                                        <div className="d-flex mb-2">
                                          <div className="d-flex align-items-end gap-2">
                                            <input
                                              className="form-control"
                                              type="number"
                                              name="sizeone"
                                              placeholder="Height"
                                              value={row.sizeone}
                                              onChange={(e) =>
                                                handleInputChange(e, index)
                                              }
                                              onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"].includes(e.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              required
                                            />
                                          </div>
                                          <h5 className="my-auto p-2">
                                            <svg
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"
                                                stroke="black"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                              />
                                            </svg>
                                          </h5>
                                          <div className="d-flex align-items-end gap-2">
                                            <input
                                              className="form-control"
                                              type="number"
                                              name="sizeTwo"
                                              placeholder="Width"
                                              value={row.sizeTwo}
                                              onChange={(e) =>
                                                handleInputChange(e, index)
                                              }
                                              onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"].includes(e.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                            />
                                           
                                          </div>
                                          {rows.length > 1 && (
                                            <button
                                              className="add-dlt-btn"
                                              onClick={() =>
                                                handleRemoveRow(index)
                                              }
                                            >
                                              <img
                                                src="/images/svg/delete.svg"
                                                className="img-width"
                                                alt=""
                                              />
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </Col>
                                  {fields.edition === "Limited Edition" && (
                                    <Col xl={6}>
                                      <FormGroup className="form-group mb-4">
                                        <Label className="mb-1">
                                          Edition Quantity
                                        </Label>
                                        <div className="position-relative">
                                          <Input
                                            type="number"
                                            name="limitededitionquantity"
                                            placeholder=""
                                            value={
                                              fields?.limitededitionquantity
                                            }
                                            maxLength={1000}
                                            onChange={onChangeHandler(
                                              "limitededitionquantity"
                                            )}
                                              onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"].includes(e.key)) {
                                                  e.preventDefault();
                                                }
                                              }}
                                            className="form-control"
                                          />
                                        </div>
                                      </FormGroup>
                                    </Col>
                                  )}
                                </div>
                              </form>
                            </FormGroup>
                          </Row>

                          <Row>
                            <Label className="head-nft">
                              Limited Edition Print Number Placement
                            </Label>

                            <div className="canvas-price">
                              <div>
                                <div className="canvas-btn">
                                 
                                  <button
                                    onClick={(e) =>
                                      handlePhysicalPrintChange(
                                        "physical_print_unique_id_placement",
                                        "Lower Left Side",
                                        e
                                      )
                                    }
                                    className={`printcommon-btn ${
                                      fields?.physical_print_unique_id_placement ===
                                      "Lower Left Side"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Lower Left Side
                                  </button>
                                   <button
                                    onClick={(e) =>
                                      handlePhysicalPrintChange(
                                        "physical_print_unique_id_placement",
                                        "Lower Right Side",
                                        e
                                      )
                                    }
                                    className={`printcommon-btn ${
                                      fields?.physical_print_unique_id_placement ===
                                      "Lower Right Side"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Lower Right Side
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Row>
                        </div>
                      </Col>
                    </Row>

                    <div>
                      <p className="linktext authtext">
                        <span onClick={Authenticity}>
                          <b className="text-bold">
                            Certificate of Authenticity
                          </b>
                        </span>
                      </p>
                    </div>

                    <FormGroup>
                      <div className="text-center Done-wrap">
                        <button
                           type="button"
                          className="btn btn-secondary text-white fw-semibold px-5"
                          onClick={ondatasubmit}
                        >
                          List on Marketplace
                        </button>
                      </div>
                    </FormGroup>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Col>
      </Row>
    </>
  );
}
